// Versión del frontend y detección de despliegues nuevos. Independiente de la sesión: actualizar NUNCA cierra sesión.
// La versión se fija en el build (REACT_APP_VERSION) y el servidor publica la vigente en /version.json (sin caché).
//   { "version": "2026.11.01.153012", "minima": "" }  → minima: versión mínima compatible con la API (opcional).
import { diag } from './diagnostico';

export const VERSION_ACTUAL = process.env.REACT_APP_VERSION || '';

/** Consulta la versión publicada. Devuelve null si no se pudo (sin red, desarrollo): no se avisa nada. */
export async function versionPublicada() {
  try {
    const r = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
    if (!r.ok) return null;
    const j = await r.json();
    return j && typeof j.version === 'string' ? j : null;
  } catch { return null; }
}

/** 'igual' | 'nueva' | 'obligatoria' (esta versión ya no es compatible con la API) | 'desconocida'. */
export function compararVersion(publicada, actual = VERSION_ACTUAL) {
  if (!publicada?.version || !actual) return 'desconocida';
  if (publicada.version === actual) return 'igual';
  if (publicada.minima && actual < publicada.minima) return 'obligatoria'; // formato AAAA.MM.DD.HHMMSS: comparable como texto
  return 'nueva';
}

// Formularios con cambios sin guardar: las pantallas se registran (p. ej. la caja con avance sin guardar).
const pendientes = new Set();
export function marcarCambiosPendientes(id, hay) { if (hay) pendientes.add(id); else pendientes.delete(id); }
/** Hay riesgo de perder datos al recargar: cambios registrados o un formulario/ventana de edición abierto. */
export function hayCambiosSinGuardar() {
  if (pendientes.size) return true;
  try { return !!document.querySelector('form [role="dialog"], [role="dialog"] form, .fx-modal, .usuarios-modal'); } catch { return false; }
}

/** Recarga solo el frontend: el token, la sucursal y las preferencias quedan en el navegador y se restauran. */
export function recargarAplicacion() {
  diag('version', 'recarga para actualizar', { desde: VERSION_ACTUAL || 'dev' });
  window.location.reload();
}

/** Retira service workers de versiones anteriores (el proyecto no usa PWA) para que no sirvan archivos viejos. */
export async function retirarServiceWorkers() {
  try {
    const regs = (await navigator.serviceWorker?.getRegistrations?.()) || [];
    for (const r of regs) await r.unregister();
    if (regs.length && window.caches) for (const k of await caches.keys()) await caches.delete(k);
    if (regs.length) diag('version', 'service worker anterior retirado', { cantidad: regs.length });
  } catch {}
}
